import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.samples'),
    id: 'generalSamples',
    sidebar: [
        {
            id: 'sampleType',
            label: i18n.tc('configuration.sections.sampleType', 2),
            icon: 'fal fa-prescription-bottle',
            routeName: 'SamplesType',
            hasChildren: false
        },
        {
            id: 'topography',
            label: i18n.t('configuration.sections.topography'),
            icon: 'fal fa-map-pin',
            routeName: 'TopographicCodes',
            hasChildren: false
        },
        {
            id: 'morphology',
            label: i18n.t('configuration.sections.morphology'),
            icon: 'fal fa-shapes',
            routeName: 'SamplesMorphology',
            hasChildren: false
        },
        {
            id: 'procedure',
            label: i18n.tc('configuration.sections.procedures', 2),
            icon: 'fal fa-medkit',
            routeName: 'SamplesProcedures',
            hasChildren: false
        },
        {
            id: 'mostLikelyDiagnose',
            label: i18n.tc('configuration.sections.mostLikelyDiagnoses', 2),
            icon: 'fal fa-file-chart-line',
            routeName: 'SamplesMostLikelyDiagnoses',
            hasChildren: false
        },
        {
            id: 'processesType',
            label: i18n.tc('configuration.sections.processesType', 2),
            icon: 'fal fa-tint',
            routeName: 'SamplesProcessesTypes',
            hasChildren: false
        }
    ]
}
